import { HeadingDescSmall, SectionHeadingSmall } from '../../Headings';
// import ListHeading from '../../Headings/listHeading/ListHeading';
// import Status from '../../status/Status';
import { RightArrowWithBorder } from '../../icons';
import { AnchorLink } from '../../button';
import './cardWithLeftImage.css';

function CardWithLeftImage(props) {
  const { image, heading, desc, children, btnText } = props;

  return (
    <div className="card cardWithLeftImage">
      <div className="card_img">
        <img src={image} alt="img" />
      </div>
      <div className="card_body">
        <div className="d-flex">
          {/* <Status progress="verified" text="VERIFIED" />
              <Status progress="fact" text="FACT CHECKED" /> */}
        </div>
        {/* <ListHeading text="Make the Most of Your Safer-at-Home" /> */}
        <SectionHeadingSmall text={heading} />
        <HeadingDescSmall text={desc} />
        {children}
        {btnText && (
          <div className="d-flex mt-4">
            <RightArrowWithBorder />
            <AnchorLink text={btnText} />
          </div>
        )}
      </div>
    </div>
  );
}

export default CardWithLeftImage;
